// extracted by mini-css-extract-plugin
export default {"heading":"hB-z","corrected":"iB-z","redirectVerbiageContainer":"jB-z","redirectVerbiageText":"kB-z"};